import React, { useState, useEffect } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Dialog, Fade, Grid, Grow, Icon, IconButton, makeStyles, Modal, Typography, withStyles } from '@material-ui/core';
import { blueGrey } from '@material-ui/core/colors';
import { Pagination } from '@material-ui/lab';
import moment from 'moment';
import transaction_icon from '../../../assets/images/transaction.png'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Grow ref={ref} {...props} timeout={500} />;
});

const TransactionModal = ({open, onClose, transactions}) => {

    const classes = useStyles()

    const [selected, setSelected] = useState(null)
    const [limit, setLimit] = useState(25)
    const [page, setPage] = useState(1)
    

    const onSelectedAccordion = (val) => {
        if(val === selected){
            setSelected(null)
        }else{
            setSelected(val)
        }
        
    }

    const onChangePage = (e, _page) => {
        //console.log(_page)
        setPage(_page)
    }

    const pages = Math.ceil(transactions.length / limit)

    let _innertrans = []

    if(transactions && transactions.length){
        const start_point = (page-1)*limit
        _innertrans = transactions.slice(start_point, start_point+limit)
    }
    return ( 
        <Dialog open={open} classes={{paper:classes.paper}} fullWidth maxWidth='sm' TransitionComponent={Transition} >
            <div className={classes.root}>
                
                    <Grid container>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs>
                                    <Typography variant='subtitle1' className={classes.title}>Transactions</Typography>
                                </Grid>
                                <Grid item>
                                    <IconButton onClick={onClose}>
                                        <Icon>close</Icon>
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                        <div className={classes.container}>
                            {transactions.length === 0 ? (
                                <div style={{padding:40}}>
                                    <Fade in timeout={500}>
                                        <Grid container alignItems='center' direction='column' spacing={2}>
                                            <Grid item>
                                                <img src={transaction_icon} alt='' className={classes.image} />
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='subtitle2' color='textSecondary'>The are no transactions available</Typography>
                                            </Grid>
                                        </Grid>
                                    </Fade>
                                    
                                </div>
                            ) : (
                                <>
                                {_innertrans.map(item => {
                                    return(
                                        <Accordion expanded={item.idTran === selected} onChange={() => onSelectedAccordion(item.idTran)}>
                                            <AccordionSummary>
                                                <Grid container>
                                                    <Grid item xs={6}>
                                                        <Grid container>
                                                            <Grid item xs={12}>
                                                                <Typography className={classes.caption}>{moment(item.requestDate).format('MM/DD/YYYY')}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Typography className={classes.label}>{item.transTypeDescription}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Typography className={classes.caption}>{item.idTran}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <div className={classes.price_container}>
                                                            <IconButton color='primary' size='small' className={classes.details_btn}><Icon  >
                                                                {selected ? 'remove_circle_outline' : 'add_circle_outline'}
                                                            </Icon></IconButton>
                                                            <Grid container>
                                                                <Grid item xs={12}>
                                                                    <Grid item xs={12}>
                                                                        <Typography align='right' className={classes.price}>{`$${item.responseAmount}`}</Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </div>
                                                        
                                                    </Grid>
                                                </Grid>
                                                
                                            </AccordionSummary>
                                            <MuiAccordionDetails>
                                                <Grid container>
                                                    {item.childTransactions.map(el => {
                                                        return(
                                                            <Grid item xs={12} key={el.idTran.toString()}>
                                                                <DetailTransaction item={el} />
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </MuiAccordionDetails>
                                        </Accordion>
                                    )
                                })}
                                </>
                            )}
                        </div>
                            
                                
                            
                        </Grid>
                        {transactions.length ? (
                            <Grid item xs={12}>
                                <div style={{paddingTop:24}}>
                                    <Pagination count={pages} onChange={onChangePage} defaultPage={page} page={page} />
                                </div>
                            </Grid>
                        ) : null}
                        
                    </Grid>
                
                
            </div>
        </Dialog>
     );
}

const useStyles = makeStyles(theme => ({
    image:{
        width:160
    },
    paper:{
        borderRadius:16
    },
    root:{
        padding:32,
        //width:600,
        boxSizing:'border-box',
       
    },
    container:{
        maxHeight:450,
        overflowY:'auto',
    },
    price_container:{
        height:'100%',
        //background:'red',
        position:'relative'
    },
    details_btn:{
        position:'absolute',
        bottom:8,
        right:0,
        color:blueGrey[300],
        padding:0
    },
    caption:{
        color:blueGrey[200],
        fontSize:13
    },
    label:{
        color:blueGrey[500],
        fontSize:14,
        fontWeight:600
    },
    title:{
        color:theme.palette.primary.main,
        fontSize:24,
        fontWeight:700
    },
    price:{
        color:theme.palette.primary.main,
        fontSize:18,
        fontWeight:700
    }
}))
 
export default TransactionModal;


const DetailTransaction = ({item}) => {

    const classes = useTransStyles()

    return(
        <div className={classes.root}>
            <Grid container>
                <Grid item xs={6}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography className={classes.caption}>{moment(item.requestDate).format('MM/DD/YYYY')}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography className={classes.label}>{item.transTypeDescription}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography className={classes.caption}>{item.idTran}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <div className={classes.price_container}>
                        <Grid container>
                            <Grid item xs={12}>
                                <Grid item xs={12}>
                                    <Typography align='right' className={classes.price}>{`$${item.responseAmount}`}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                    
                </Grid>
            </Grid>
        </div>
        
    )
}

const useTransStyles = makeStyles(theme => ({
    root:{
       
    },
    caption:{
        color:blueGrey[200],
        fontSize:13
    },
    label:{
        color:blueGrey[500],
        fontSize:14,
        fontWeight:600
    },
    title:{
        color:theme.palette.primary.main,
        fontSize:24,
        fontWeight:700
    },
    price:{
        color:theme.palette.primary.main,
        fontSize:18,
        fontWeight:700
    }
}))


const MuiAccordionDetails = withStyles((theme) => ({
    root: {
        background:blueGrey[100],
        padding: theme.spacing(2),
        border:0,
        boxShadow:'none'
    },
}))(  AccordionDetails);

